export const HAS_LOGGED_IN = 'HAS_LOGGED_IN' as const;
export const PENDING_LOGIN = 'PENDING_LOGIN' as const;
export const NOT_AVAILABLE = 'NOT_AVAILABLE' as const;

export const PROFILE_TYPES = {
	user: 'User',
	organization: 'Organisation',
} as const;
